export default Object.freeze({
    // Legacy subscription values
    NETWORK: 'NETWORK',
    PREMIUM: 'PREMIUM',
    TRIAL_PERIOD: 'TRIAL_PERIOD',
    ENTERPRISE: 'ENTERPRISE',
    PENDING_TRIAL: 'PENDING_TRIAL',

    // Plan-engine codes
    FREE: 'FREE',
    STARTER: 'STARTER',
    PROFESSIONAL: 'PROFESSIONAL',
    PRACTICE_PLUS: 'PRACTICE_PLUS',
    CUSTOM: 'CUSTOM',
    ANCILLARY_PREMIUM: 'ANCILLARY_PREMIUM',
})
